import React from "react";

/**
 * Estrelas VISUAIS a partir de uma nota 0–10 (mapeadas para 5 estrelas, com preenchimento parcial).
 * Camada cinza (fundo) + camada dourada recortada por largura % = nota proporcional.
 */
export default function Stars({ score = 0, size = 18, className = "" }) {
  const n = Number(score) || 0;
  const pct = Math.max(0, Math.min(100, (n / 10) * 100));
  return (
    <span
      className={`relative inline-block whitespace-nowrap leading-none align-middle ${className}`}
      style={{ fontSize: size, letterSpacing: "1px" }}
      title={`${n.toFixed(1)}/10`}
      aria-label={`Nota ${n.toFixed(1)} de 10`}
    >
      <span className="text-gray-300">★★★★★</span>
      <span className="absolute inset-0 overflow-hidden text-yellow-400" style={{ width: `${pct}%` }}>★★★★★</span>
    </span>
  );
}
